export default {"src":"/_next/static/media/fewClouds.256616be.svg","height":189,"width":189};